import type { ReactNode } from 'react';
import { Box, Divider, Paper } from '@mui/material';
import { ListRow, designTokens } from '../../../design-system';

type IntegrationNavigationItem = {
  label: string;
  description: string;
  icon: ReactNode;
  value?: ReactNode;
  ariaLabel?: string;
  onOpen?: () => void;
  disabled?: boolean;
};

export function IntegrationNavigationList({ items, label }: {
  items: IntegrationNavigationItem[];
  label: string;
}) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: designTokens.radius.surface, p: `${designTokens.space.xs}px` }}>
      <Box component="ul" aria-label={label} sx={{ m: 0, p: 0, listStyle: 'none' }}>
        {items.map((item, index) => (
          <Box component="li" key={item.label}>
            {index > 0 && <Divider sx={{ mx: `${designTokens.space.md}px` }} />}
            <ListRow
              label={<Box component="span" sx={designTokens.typography.componentTitle}>{item.label}</Box>}
              description={item.description}
              icon={item.icon}
              value={item.value}
              ariaLabel={item.ariaLabel ?? item.label}
              onClick={item.onOpen}
              disabled={item.disabled}
            />
          </Box>
        ))}
      </Box>
    </Paper>
  );
}
